import { saveAs } from 'file-saver'

function resolve(path, obj, separator='.') {
    var properties = Array.isArray(path) ? path : path.split(separator)
    return properties.reduce((prev, curr) => prev?.[curr], obj)
}

export const downloadCSV = (filename, data, keys, headers) => {
    var blob = new Blob(['\uFEFF'+headers.join()+'\r\n'].concat(data.map((el) => (
        keys.map(k => (resolve(k, el))).join() + '\r\n'
    ))), { type: "text/csv;charset=utf-16" })
    // var blob = new Blob(['longitude,latitude\r\n'].concat(dat.map((el) => (el.geometry.coordinates + '\r\n'))), { type: "text/csv;charset=utf-16" });
    saveAs(blob, filename);
}

export const parseFleetName = (fleet, portData) => {
return {fleet: fleet, 
    shiptype: fleet.split("_")[0], 
    portA: findPortName(fleet.split("_")[1], portData),
    portB: findPortName(fleet.split("_")[2], portData),
}
}

export const findPortName = (locode, portData) => {
    const ports = portData.filter(el => el.locode === locode)
    if (ports.length) {
        return ports[0].name
    } else {
       return locode
    }
   }